import React, { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useChannels } from '../context/CategoriesContext';

const STATIC_MS = 380;
const OSD_MS = 1800;

function useNoise(canvasRef, active) {
  useEffect(() => {
    if (!active || !canvasRef.current) return undefined;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const img = ctx.createImageData(canvas.width, canvas.height);
    let raf;
    const draw = () => {
      const d = img.data;
      for (let i = 0; i < d.length; i += 4) {
        const v = Math.random() * 255;
        d[i] = v; d[i + 1] = v * 0.92; d[i + 2] = v * 0.78; d[i + 3] = 255;
      }
      ctx.putImageData(img, 0, 0);
      raf = requestAnimationFrame(draw);
    };
    draw();
    return () => cancelAnimationFrame(raf);
  }, [canvasRef, active]);
}

export default function ChannelStatic() {
  const { pathname } = useLocation();
  const channels = useChannels();
  const canvasRef = useRef(null);
  const prevPath = useRef(pathname);
  const [burst, setBurst] = useState(null);
  const [showStatic, setShowStatic] = useState(false);

  useEffect(() => {
    if (prevPath.current === pathname) return undefined;
    prevPath.current = pathname;
    const idx = channels.findIndex((c) => c.path === pathname);
    const ch = channels[idx];
    const header = document.querySelector('#tv-screen-root > header');
    // Match the home page inputs: home is 00, then each channel counts up from 01.
    const num = ch?.key === 'home' ? 0 : channels.filter((c) => c.key !== 'home').indexOf(ch) + 1;
    setBurst({
      id: Date.now(),
      top: (header?.offsetHeight || 0) + 10,
      num: pathname.startsWith('/admin') ? 'AUX' : idx === -1 ? 'CH --' : `CH ${String(num).padStart(2, '0')}`,
      name: pathname.startsWith('/admin') ? 'CONTROL ROOM' : ch ? ch.name : 'NO SIGNAL'
    });
    setShowStatic(true);
    const t1 = setTimeout(() => setShowStatic(false), STATIC_MS);
    const t2 = setTimeout(() => setBurst(null), OSD_MS);
    return () => { clearTimeout(t1); clearTimeout(t2); };
    // Only fire on actual route changes, not when the channel list reloads.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useNoise(canvasRef, showStatic);

  if (!burst) return null;
  return (
    <>
      {showStatic && (
        <canvas ref={canvasRef} width={160} height={100} aria-hidden data-testid="channel-static"
                className="channel-static absolute inset-0 w-full h-full pointer-events-none" />
      )}
      <div key={burst.id} className="channel-osd absolute pointer-events-none font-osd" style={{ top: burst.top }} data-testid="channel-osd">
        <div className="channel-osd-num">{burst.num}</div>
        <div className="channel-osd-name">{burst.name}</div>
      </div>
    </>
  );
}
